<script>
import { Line, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  methods: {
    renderLineChart() {
      this.renderChart(this.data, this.options);
    },
  },
  mounted() {
    // this.chartData is created in the mixin.
    this.renderLineChart();
  },
  watch: {
    chartData() {
      this.renderLineChart();
    },
  },
  computed: {
    data() {
      return this.chartData;
    },
  },
};
</script>
